import React from "react";
import { ToastContainer } from "react-toastify";

import style from "./Toaster.scss";

export const Toaster = () => <ToastContainer className={style.toastContainer} />;
